export default __webpack_public_path__ + "static/Indianapolis-784bd4ea28ee7a0b4f5a34eaef4a81e6.webp";